<template>
  <div class="Repair">
    <div class="middle">
      <div class="common-title">报修申请</div>
      <div class="table-block">
        <div class="common-form">
          <el-form label-width="80px">
            <el-form-item label="所属街道">
              <el-cascader v-model="value" :options="options"></el-cascader>
              <!-- <el-input v-model="params.positionDesc" placeholder="请输入街道"></el-input> -->
            </el-form-item>
            <el-form-item label="时间" label-width="80px">
              <el-date-picker
                v-model="start_end_Date"
                type="datetimerange"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                range-separator="至"
              ></el-date-picker>
            </el-form-item>

            <el-form-item label="" label-width="40px">
              <el-input
                v-model="params.keyWord"
                placeholder="模糊查询"
              ></el-input>
            </el-form-item>
            <el-form-item label="" label-width="40px">
              <div class="btn-group">
                <div class="search-btn" @click="handleSearch">查询</div>
                <div class="search-btn" @click="handleReset">重置</div>
              </div>
            </el-form-item>
          </el-form>
        </div>
        <div class="common-table">
          <el-table
            :data="tableData"
            :row-class-name="tableRowClassName"
            style="width: 100%"
          >
            <el-table-column
              label="序号"
              align="center"
              width="100"
              type="index"
            >
              <template slot-scope="scope">
                <span>{{
                  (params.pageNo - 1) * params.pageSize + scope.$index + 1
                }}</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="reporter"
              label="报修人"
              width="100"
            ></el-table-column>
            <el-table-column label="联系电话" width="160">
              <template slot-scope="scope">
                <div>{{ scope.row.phone || "暂无" }}</div>
              </template>
            </el-table-column>
            <el-table-column
              prop="position_name"
              label="报修地址"
              show-overflow-tooltip
            ></el-table-column>
            <el-table-column
              prop="position_des"
              label="故障地址"
              show-overflow-tooltip
            ></el-table-column>
            <el-table-column label="故障描述" show-overflow-tooltip>
              <template slot-scope="scope">
                <div>{{ scope.row.report_inf || "暂无" }}</div>
              </template>
            </el-table-column>
            <el-table-column
              prop="work_order_time"
              label="创建日期"
            ></el-table-column>
            <el-table-column
              label="操作"
              align="center"
              width="100"
              type="index"
            >
              <template slot-scope="scope">
                <div class="btn" @click="seeDetail(scope.row)">详情</div>
              </template>
            </el-table-column>
          </el-table>
          <div class="common-pagination">
            <el-pagination
              :current-page.sync="params.pageNo"
              :page-size="params.pageSize"
              layout="prev, pager, next, jumper"
              :total="total"
              @current-change="handleCurrentChange"
            >
            </el-pagination>
          </div>
        </div>
      </div>
    </div>
    <detail-message :dialog-state="dialogState"></detail-message>
    <div class="middle-block">
      <div
        v-show="switchs === 'out'"
        class="switch-item animate__animated animate__fadeInLeft"
        @click="switchs = 'switchs'"
      ></div>
      <div
        v-show="switchs === 'switchs'"
        class="switchs animate__animated animate__fadeInLeft"
      >
        <div class="in"></div>
        <div class="page">
          <div class="page1" @click="goTo('/')">首页</div>
          <div class="page2" @click="goTo('/user')">用户管理</div>
        </div>
      </div>
      <div
        v-show="switchs === 'switchs'"
        class="in-kuohu animate__animated animate__fadeInLeft"
        @click="switchs = 'out'"
      ></div>
    </div>
  </div>
</template>

<script>
import DetailMessage from './dialog/DetailMessage.vue'
export default {
  name: 'Repair',
  components: {
    DetailMessage
  },
  data() {
    return {
      options: [],
      switchs: 'out',
      value: '',
      tableData: [],
      start_end_Date: '',
      total: 0,
      dialogState: {
        visible: false,
        method: '',
        params: ''
      },
      params: {
        positionDesc: '',
        pageNo: 1,
        pageSize: 15,
        keyWord: ''
      }
    }
  },
  created() {
    // listMaintenancePoint
    this.getAreaList()
    this.handleSearch()
  },
  methods: {
    goTo(url) {
      this.$router.push(url)
    },
    handleReset() {
      this.value = ''
      this.params.positionDesc = ''
      this.handleSearch()
    },
    tableRowClassName({ row, rowIndex }) {
      return 'table-row'
    },
    seeDetail(item) {
      this.dialogState.visible = true
      this.dialogState.params = item
    },
    handleCurrentChange(val) {
      this.params.pageNo = val
      this.handleSearch()
    },
    handleSearch() {
      if (this.value && this.value.length > 0) {
        this.params.positionDesc = this.value[this.value.length - 1]
      }
      if (this.start_end_Date) {
        this.params.startTime =
          this.moment(this.start_end_Date[0]).format('yyyy-MM-DD') +
          ' 00:00:00'
        this.params.endTime =
          this.moment(this.start_end_Date[1]).format('yyyy-MM-DD') +
          ' 23:59:59'
      } else {
        this.params.startTime = ''
        this.params.endTime = ''
      }
      this.$axios
        .post(this.ip + '/oa/listWorkOrder', this.qs.stringify(this.params))
        .then((res) => {
          const response = res.data
          if (response.code === 0) {
            this.tableData = response.data.list
            this.tableData.forEach((el) => {
              el.work_order_time = this.moment(el.work_order_time).format(
                'yyyy-MM-DD HH:mm:ss'
              )
              console.log(el.phone)
              el.phone = el.phone.length < 3 ? '暂无' : el.phone
            })
            this.total = response.data.total
          }
        })
    },
    getAreaList() {
      this.$axios.get(this.ip + '/oa/listArea').then((response) => {
        const res = response.data
        if (res.code === 0) {
          res.data.forEach((el) => {
            el.children.forEach((ele) => {
              ele.label = ele.area_name
              ele.value = ele.area_name
            })
            this.options.push({
              label: el.area_name,
              value: el.area_name,
              children: el.children
            })
          })
        }
      })
    }
  }
}
</script>

<style scoped lang='scss'>
.Repair {
  .middle-block {
    position: fixed;
    left: 1px;
    top: 437px;
    .switch-item {
      width: 56px;
      cursor: pointer;
      height: 98px;
      background-color: deeppink;
      z-index: 99;
      background: url(../../assets/homeleft/out.png) no-repeat;
      background-size: 100% 100%;
    }
    .in-kuohu {
      cursor: pointer;
      position: absolute;
      left: 8px;
      top: -159px;
      width: 64px;
      height: 456px;
      background: url(../../assets/homeleft/in.png) no-repeat;
      background-size: 100% 100%;
    }
    .switchs {
      display: flex;
      .in {
        height: 98px;
        width: 56px;
        background: url(../../assets/homeleft/out.png) no-repeat;
        background-size: 100% 100%;
        transform: rotate(180deg);
      }
      .page {
        width: 120px;
        height: 240px;
        margin: -50px 0 0 30px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        div {
          padding: 20px 30px;
          margin-bottom: 20px;
          width: 108px !important;
          height: 108px;
          background: url(../../assets/homeleft/switch.png) no-repeat;
          background-size: 100% 100%;
          cursor: pointer;
          width: 47px;
          font-weight: 400;
          color: #19e0f6;
          font-size: 24px;
        }
      }
    }
  }
  .btn-group {
    display: flex;
    div {
      margin-right: 40px;
    }
  }
  .btn {
    cursor: pointer;
    color: deepskyblue;
  }
  position: relative;

  .middle {
    margin-top: 60px;
    position: absolute;
    left: 50%;
    transform: translate(-50%);
    width: 1471px;

    .table-block {
      padding: 13px 20px 0;
      width: 100%;
      height: 786px;
      margin-top: 10px;
      background-color: #00000069;
      .common-form {
        height: 40px;
        .el-form {
          display: flex;
          .search-btn {
            cursor: pointer;
            color: #fff;
          }
        }
      }
      .common-table {
        margin: 0;
      }
    }
  }
}
</style>
